import { createAppKit } from "@reown/appkit/react";
import { mainnet } from "@reown/appkit/networks"; //arbitrum, mainnet
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { config } from "@/config/index.js";
// 1. 从 https://cloud.walletconnect.com 获取你的 Project ID
const projectId = config.projectId;
// 3. 配置 Metadata
const metadata = config.metadata;

export const modal = await createAppKit({
  adapters: [new EthersAdapter()],
  networks: [mainnet],
  metadata,
  projectId,
  features: {
    enableAnalytics: true,
    onramp: false,
    socials: false,
    email: false,
  },
  wel_bg4_list:[]
});